import { Component, OnInit } from '@angular/core';
import { BaseContainerService, ModalContainerService, ModalService, BaseDataService } from 'yt-ng-framework';
import { ActivatedRoute } from '@angular/router';
import { TreeviewItem, TreeItem } from 'ngx-treeview';
import { ConvItems2Treeviewitem } from '../../core/classes/conv-items2-treeviewitem'
import { OrgJed } from './orgjed';



@Component({
  selector: 'app-orgJed',
  templateUrl: './orgjed.component.html' 
})
export class OrgJedComponent implements OnInit {
    list: TreeviewItem[];
    config= {  hasAllCheckBox: false,
      hasFilter: true,
      hasCollapseExpand: false,
      decoupleChildFromParent: true,
      maxHeight: 500
    };

  constructor(
    protected modalContainerService: ModalContainerService<OrgJed>,
    protected activatedRoute: ActivatedRoute,
    protected modalService: ModalService,
    protected baseDataService: BaseDataService,
    protected baseContainerService:BaseContainerService<OrgJed>,
    protected convItems2Tree: ConvItems2Treeviewitem
  ) { }

  ngOnInit() {
  }

  OnMainItemsLoaded(){  
  }

}
